import React from 'react';
import PrivacyPolicy from '../components/privacy-policy-new';

/**
 * Privacy Policy Page
 * Accessible at /privacy-policy
 * Used for app store compliance and direct user access
 */
const PrivacyPolicyPage: React.FC = () => {
  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
